import React from "react";
import { toast } from "sonner";
import useFetch from "@/lib/useFetch";
import api from "@/lib/api";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import StatusBadge from "@/components/common/StatusBadge";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Players() {
    const { data, reload } = useFetch("/players");
    if (!data) return <Loader />;

    const syncRoles = async (p) => {
        // demo: refresh roles via discord refresh endpoint is player-scoped; here we simulate an admin sync log
        try {
            await api.post("/discord/sync", { action: "roles" });
            toast.success(`Role sync queued for ${p.username}`);
        } catch { toast.error("Sync failed"); }
    };

    return (
        <div data-testid="admin-players">
            <PageHeader title="Players" subtitle="Registered members, Discord links and roles." />
            <div className="tactical-card rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-border text-left label-mono text-muted-foreground">
                            <th className="p-3">Player</th>
                            <th className="p-3 hidden md:table-cell">Discord</th>
                            <th className="p-3 hidden lg:table-cell">Platform</th>
                            <th className="p-3 hidden lg:table-cell">Communities</th>
                            <th className="p-3">Status</th>
                            <th className="p-3 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((p) => (
                            <tr key={p.id} data-testid={`player-row-${p.id}`} className="border-b border-border/60 hover:bg-accent/40">
                                <td className="p-3">
                                    <div className="flex items-center gap-2">
                                        <img src={p.avatar || `https://api.dicebear.com/7.x/bottts/svg?seed=${p.username}`} className="h-8 w-8 rounded-md border border-border bg-background" alt="" />
                                        <div>
                                            <div className="font-semibold text-foreground">{p.username}</div>
                                            <div className="label-mono text-muted-foreground">{(p.role || "").replace(/_/g, " ")}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="p-3 hidden md:table-cell">
                                    {p.discord ? <span className="text-discord">@{p.discord.username}</span> : <span className="text-muted-foreground">Not linked</span>}
                                </td>
                                <td className="p-3 hidden lg:table-cell text-foreground">{p.platform || "—"}</td>
                                <td className="p-3 hidden lg:table-cell text-muted-foreground">{p.communities.length}</td>
                                <td className="p-3"><StatusBadge status={p.status} /></td>
                                <td className="p-3 text-right">
                                    <Button data-testid={`sync-roles-${p.id}`} size="sm" variant="outline"
                                        className="border-hazard/40 text-hazard hover:bg-hazard/10" onClick={() => syncRoles(p)}>
                                        <RefreshCw size={13} className="mr-1" /> Sync Roles
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </div>
    );
}
